import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Body from './components/Body';
import ContactUs from './components/ContactUs';
import LogIn from './components/Login';
import Footer from './components/Footer';
import Header from './components/header';  
import Navbar from './components/NavBar';  
import AboutUs from './components/AboutUs';  
import MainImage from './components/MainImage';
import AdminSidebar from './components/AdminSidebar';
import DashBoard from './components/DashBoard';
import ImgUploadForm from './components/ImgUploadForm';
import ManagePackages from './components/ManagePackages';
import './App.css';

function App() {
  const username = 'JohnDoe'; // For Navbar on admin pages

  return (
    <Routes>
      {/* Public pages use Header */}
      <Route
        path="/"
        element={
          <>
            <Header />
            <MainImage />
            <Body />
            <Footer />
          </>
        }
      />
      <Route
        path="/contact"
        element={
          <>
            <Header />
            <ContactUs />
            <Footer />
          </>
        }
      />
      <Route
        path="/AboutUs"
        element={
          <>
            <Header />
            <AboutUs />
            <Footer />
          </>
        }
      />
      <Route
        path="/LogIn"
        element={
          <>
            <Header />
            <LogIn />
          </>
        }
      />

      <Route
        path="/Component/Dashboard"
        element={
          <div className="app-container">
            <Navbar username={username} />
            <AdminSidebar />
            <div className="content">
              <DashBoard />
            </div>
          </div>
        }
      />
      <Route
        path="/Component/ImgUploadForm"
        element={
          <div className="app-container">
            <Navbar username={username} />
            <AdminSidebar />
            <div className="content">
              <ImgUploadForm />
            </div>
          </div>
        }
      />
      <Route
        path="/Component/ManagePackages"
        element={
          <div className="app-container">
            <Navbar username={username} />
            <AdminSidebar />
            <div className="content">
              <ManagePackages />
            </div>
          </div>
        }
      />
    </Routes>
  );
}

export default App;
